import { call, put, takeEvery } from "redux-saga/effects";

import {
  COUNT_ASSESSMENTS,
  DELETE_ASSESSMENT,
  FETCH_ASSESSMENT,
  FETCH_ASSESSMENTS,
  CREATE_ASSESSMENT,
} from "./actionTypes";

import {
  countAssessmentsFailure,
  countAssessmentsSuccess,
  deleteAssessmentFailure,
  deleteAssessmentSuccess,
  fetchAssessmentFailure,
  fetchAssessmentsFailure,
  fetchAssessmentsSuccess,
  fetchAssessmentSuccess,
  createAssessmentSuccess,
  createAssessmentFailure,
} from "./action";

import {
  countAllAssessments,
  deleteAssessmentById,
  fetchAllAssessments,
  fetchAssessmentById,
  createAssessment,
} from "../../helpers/backend_helper";

import { toast } from "react-toastify";

function* workFetchAssessments() {
  try {
    const response = yield call(fetchAllAssessments);
    yield put(fetchAssessmentsSuccess(response.data));
  } catch (error) {
    yield put(fetchAssessmentsFailure(error));
  }
}

function* workFetchAssessment({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(fetchAssessmentById, id);
    yield put(fetchAssessmentSuccess(response.data));
  } catch (error) {
    yield put(fetchAssessmentFailure(error));
  }
}

function* workDeleteAssessment({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(deleteAssessmentById, id);
    yield put(deleteAssessmentSuccess(response.data));
    toast.success("Assessment deleted successfully");
  } catch (error) {
    yield put(deleteAssessmentFailure(error));
    toast.error("Error deleting assessment");
  }
}

function* workCountAssessments() {
  try {
    const response = yield call(countAllAssessments);
    yield put(countAssessmentsSuccess(response.data));
  } catch (error) {
    yield put(countAssessmentsFailure(error));
    toast.error("Failed to count assessments.");
  }
}

function* workCreateAssessment({ payload }) {
  const { randomizedBoolean, data } = payload;
  try {
    const response = yield call(createAssessment, randomizedBoolean, data);
    yield put(createAssessmentSuccess(response.data));
    toast.success("Assessment created successfully!");
  } catch (error) {
    yield put(createAssessmentFailure(error));
    toast.error("Error creating assessment!");
  }
}

export default function* watchFetchAssessments() {
  yield takeEvery(FETCH_ASSESSMENTS, workFetchAssessments);
  yield takeEvery(FETCH_ASSESSMENT, workFetchAssessment);
  yield takeEvery(DELETE_ASSESSMENT, workDeleteAssessment);
  yield takeEvery(COUNT_ASSESSMENTS, workCountAssessments);
  yield takeEvery(CREATE_ASSESSMENT, workCreateAssessment);
}
